import { useState, useCallback } from 'react';
import { message } from 'antd';
import { p9315Api, QueryParams, AttendanceRow } from '../../../services/p9315Api';

export function useP9315Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<AttendanceRow[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);
  const [daysInMonth, setDaysInMonth] = useState(31);
  const [queryYear, setQueryYear] = useState<number>(0);
  const [queryMonth, setQueryMonth] = useState<number>(0);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await p9315Api.query(params);
      setDaysInMonth(resp.daysInMonth || 31);
      setQueryYear(resp.year);
      setQueryMonth(resp.month);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setNoData(false);
      } else {
        setData([]);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch (err: unknown) {
      const axiosErr = err as { response?: { status?: number; data?: { error?: string; details?: string[] } } };
      if (axiosErr.response?.status === 400) {
        const errMsg = axiosErr.response.data?.error || '查詢參數驗證失敗';
        message.error(errMsg);
      } else if (axiosErr.response?.status === 422) {
        const details = axiosErr.response.data?.details || [];
        message.error(details.join('\n') || '查詢參數驗證失敗');
      } else {
        message.error('查詢失敗，請稍後再試');
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setQueried(false);
    setNoData(false);
    setDaysInMonth(31);
    setQueryYear(0);
    setQueryMonth(0);
  }, []);

  return { loading, data, queried, noData, daysInMonth, queryYear, queryMonth, runQuery, reset };
}
